import script from "./ProtocolGateway.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProtocolGateway.vue?vue&type=script&setup=true&lang=ts"

import "./ProtocolGateway.vue?vue&type=style&index=0&id=164f9b87&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164f9b87"]])

export default __exports__